import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import SubscribeNewsletterBtn from './SubscribeNewsletterBtn';
import { loadNewsletter } from '../../../actions';
import TruncatedText from '../../../utils/truncatedText';

class Newsletter extends Component {
  constructor(props) {
    super(props);
  }

  handleClick = () => {
    this.props.onClick(this.props.newsletter.id);
  }

  

  render() {
    let newsletterData = this.props.newsletter || null;
    if (!newsletterData) {
      return <span />;
    }

    let browser = this.props.browser || null;

    if (!browser) {
      return <span />;
    }

    let newsletterImage = '';
    if (browser.width < 750) {
      newsletterImage = newsletterData.header_image_mobile || null;
    } else {
      newsletterImage = newsletterData.header_image || null;
    }

    let newsletterImageDesktop = newsletterData.header_image || null;
    let newsletterImageMobile = newsletterData.header_image_mobile || null;

    let newsletterTitle = newsletterData.title || '';
    let newsletterDescription = newsletterData.excerpt || '';
    let excerptLength = this.props.excerptLength || 30;
    let newsletterCategory = newsletterData.category || '';
    let newsletterDate = newsletterData.newsletter_status_changed || '';
    // Format the date as Month Day, Year
    let newsletterDateFormatted = new Date(newsletterDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    let newsletterUrl = newsletterData.url || '';
    let newsletterId = newsletterData.id || '';

    let ltsNewsletter = (
      <div className="ltsNewsletter-outer">
        <div className="ltsNewsletter-inner">
          <div onClick={this.handleClick} className="home-newsletter-itemWrapper">
            <div className="home-newsletter-left-image">
              <div><img src={newsletterImage} /></div>
              <div className="home-newsletter-date">{newsletterDateFormatted}</div>
            </div>
            
            <div className="newsletter-copyWrapper home-newsletter-right-item">
              <div className="category-title">{newsletterCategory}</div>
              <h3 className="home-newsletter-copy-title">{newsletterTitle}</h3>
              

              <p className="home-newsletter-description-item"><TruncatedText text={newsletterDescription} maxWords={excerptLength} /></p>
            </div>
          </div>

          
          
        </div>
        <div className="home-newsletter home-newsletter-via">Via <span className="home-newsletter-via-name">WorldWideWomen</span></div>
      </div>
      
      
    );
          


    return(
      <div className="home-newsletter-itemWrapper-outer">
        {ltsNewsletter}
      </div>
    );
  }
}

function mapStateToProps(state) {
    return state;
};

export default connect(
    mapStateToProps,
    {
        Link,
        push,
        loadNewsletter,
    }
)(Newsletter);


// WEBPACK FOOTER //
// ./src/components/home/HomeNewsletter/Newsletter.jsx